import { Posting } from '../models/posting.model';
import { HttpErrorResponse } from '@angular/common/http';
import { IFetchEntityFailureActionPayload } from 'app/projects/entity/src/lib/interfaces/fetch-entity-failure-payload.interface';
import { ICreateEntityFailureActionPayload } from 'app/projects/entity/src/lib/interfaces/create-entity-failure-payload.interface';
import { IUpdateEntityFailureActionPayload } from 'app/projects/entity/src/lib/interfaces/update-entity-failure-payload.interface';
import { EngageCategory } from '../models/engage-category.model';
import { EngageCategoryWithPosting } from '../models/engage-category-with-posting.model';

export class SetPosting {
    static readonly type = '[Posting] SetPosting';

    constructor(public payload) {}
}

export class UnsetPosting {
    static readonly type = '[Posting] UnsetPosting';

    constructor(public payload) {}
}

export class FetchPosting {
    static readonly type = '[Posting] FetchPosting';

    constructor(public payload: string) {}
}

export class FetchPostingSuccess {
    static readonly type = '[Posting] FetchPostingSuccess';

    constructor(public payload: Posting) {}
}

export class FetchPostingFailure {
    static readonly type = '[Posting] FetchPostingFailure';

    constructor(public payload: IFetchEntityFailureActionPayload) {}
}

export class CreatePosting {
    static readonly type = '[Posting] CreatePosting';

    constructor(public payload: Posting) {}
}

export class CreatePostingSuccess {
    static readonly type = '[Posting] CreatePostingSuccess';

    constructor(public payload: Posting) {}
}

export class CreatePostingFailure {
    static readonly type = '[Posting] CreatePostingFailure';

    constructor(public payload: ICreateEntityFailureActionPayload) {}
}

export class CreatePostingFromArticle {
    static readonly type = '[Posting] CreatePostingFromArticle';

    constructor(public payload: Posting) {}
}

export class CreatePostingFromArticleSuccess {
    static readonly type = '[Posting] CreatePostingFromArticleSuccess';

    constructor(public payload: Posting) {}
}

export class CreatePostingFromArticleFailure {
    static readonly type = '[Posting] CreatePostingFromArticleFailure';

    constructor(public payload: ICreateEntityFailureActionPayload) {}
}

export class UpdatePostingFromArticle {
    static readonly type = '[Posting] UpdatePostingFromArticle';

    constructor(public payload: Posting) {}
}

export class UpdatePostingFromArticleSuccess {
    static readonly type = '[Posting] UpdatePostingFromArticleSuccess';

    constructor(public payload: Posting) {}
}

export class UpdatePostingFromArticleFailure {
    static readonly type = '[Posting] UpdatePostingFromArticleFailure';

    constructor(public payload: ICreateEntityFailureActionPayload) {}
}

export class UpdatePosting {
    static readonly type = '[Posting] UpdatePosting';

    constructor(public payload: Posting) {}
}

export class UpdatePostingSuccess {
    static readonly type = '[Posting] UpdatePostingSuccess';

    constructor(public payload: Posting) {}
}

export class UpdatePostingFailure {
    static readonly type = '[Posting] UpdatePostingFailure';

    constructor(public payload: IUpdateEntityFailureActionPayload) {}
}

export class DeletePosting {
    static readonly type = '[Posting] DeletePosting';

    constructor(public payload: string) {}
}

export class DeletePostingSuccess {
    static readonly type = '[Posting] DeletePostingSuccess';

    constructor(public payload: string) {}
}

export class DeletePostingFailure {
    static readonly type = '[Posting] DeletePostingFailure';

    constructor(
        public payload: {
            response: HttpErrorResponse;
        }
    ) {}
}

export class SetPostings {
    static readonly type = '[Posting] SetPostings';

    constructor(public payload: Posting[]) {}
}

export class SetSortBySelected {
    static readonly type = '[Posting] SetSortBySelected';

    constructor(public payload: string) {}
}

export class SetSortOrderSelected {
    static readonly type = '[Posting] SetSortOrderSelected';

    constructor(public payload: string) {}
}

export class AddPostings {
    static readonly type = '[Posting] AddPostings';

    constructor(public payload: Posting[]) {}
}

export class FetchPostings {
    static readonly type = '[Posting] FetchPostings';
}

export class FetchPostingsSuccess {
    static readonly type = '[Posting] FetchPostingsSuccess';
}

export class FetchPostingsFailure {
    static readonly type = '[Posting] FetchPostingsFailure';
}

export class FetchEngageCategories {
    static readonly type = '[Posting] FetchEngageCategories';
    constructor(public payload: { audienceId: string; searchTerm: string; postingTypeId: number; sectionId?: string; courseOfferingId?: string }) {}
}

export class FetchEngageCategoriesSuccess {
    static readonly type = '[Posting] FetchEngageCategoriesSuccess';

    constructor(public payload: EngageCategory[]) {}
}

export class FetchEngageCategoriesFailure {
    static readonly type = '[Posting] FetchEngageCategoriesFailure';
}

export class FetchEngageCategoriesWithPostings {
    static readonly type = '[Posting] FetchEngageCategoriesWithPostings';
    constructor(public payload: { audienceId: string; sectionId?: string; courseOfferingId?: string }) {}
}

export class FetchEngageCategoriesWithPostingsSuccess {
    static readonly type = '[Posting] FetchEngageCategoriesWithPostingsSuccess';

    constructor(public payload: EngageCategoryWithPosting[]) {}
}

export class FetchEngageCategoriesWithPostingsFailure {
    static readonly type = '[Posting] FetchEngageCategoriesWithPostingsFailure';
}
